import { Bell } from 'lucide-react';
import { useLocation } from 'wouter';
import { useUnreadNotificationsCount } from '@/hooks/use-notifications';
import { cn } from '@/lib/utils';

export function NotificationBell({ className }: { className?: string }) {
  const [, setLocation] = useLocation();
  const { data: unreadCount } = useUnreadNotificationsCount();

  const handleClick = () => {
    // Push a new history entry so browser back returns to the exact previous URL
    // (including query params like ?tab=documents).
    setLocation('/notifications', { replace: false });
  };

  return (
    <button
      onClick={handleClick}
      className={cn(
        'relative p-2 rounded-full hover:bg-gray-100 transition-colors focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2',
        className
      )}
      aria-label="Notifications"
    >
      <Bell className="w-5 h-5 text-gray-600" />
      {unreadCount && unreadCount > 0 && (
        <span className="absolute -top-0.5 -right-0.5 min-w-[18px] h-[18px] px-1 bg-red-500 rounded-full flex items-center justify-center">
          <span className="text-white text-xs font-bold leading-none">
            {unreadCount > 99 ? '99+' : unreadCount}
          </span>
        </span>
      )}
    </button>
  );
}
